<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form.search
          input(type="search" placeholder="Искать вдоль маршрута")

    div.new-map
      div#map.bigmap
      transition(name="fade")
        div.legend.cuscroll(:class="showRight ? 'open' : 'close'")
          div.head(@click="showRight = !showRight")
            //h2.title Сейчас на линии
            div.subtitle Мусоровоз №1 ( Г153ОР86RUS)
            //div.legend-info 58 из 63 машин
            span.legend__close(v-if="showRight")
            span.legend__open(v-else)
          div.type-group
            div.route-info
              div.route-info-line
                label Начало работы:
                span 08:15 (ул Строителей, 68)
              div.route-info-line
                label Окончание работы:
                span 11:15 (предполагаемое)

          div.type-group.route
            div.group.flex
              div.type
                div.marker.passed
                  span.station ул Строителей, 68
                  span.time 18 мин

              div.type
                div.marker.passed
                  span.station Парковая улица, 43
                  span.time

              div.type
                div.marker.passed
                  span.station Парковая улица, 33
                  span.time

              div.type
                div.marker.active
                  span.station Парковая улица, 19
                  span.time 0 мин


              div.type
                div.marker.coming
                  span.station улица Чехова, 68
                  span.time 10 мин

              div.type
                div.marker.coming
                  span.station улица Чехова, 72А
                  span.time 18 мин

              div.type
                div.marker.coming
                  span.station улица Чкалова, 44А
                  span.time 28 мин

              div.type
                div.marker.coming
                  span.station Красноармейская улица, 41
                  span.time 35 мин
              div.type
                div.marker.coming
                  span.station улица Мира, 71А
                  span.time 45 мин


              div.type
                div.marker.coming
                  span.station улица Шевченко, 25
                  span.time 53 мин

              div.type
                div.marker.coming
                  span.station улица Доронина, 6
                  span.time 1 ч 5 мин
              div.type
                div.marker.coming
                  span.station улица Доронина, 19
                  span.time 1 ч 15 мин

            //-
              div.type
                div.marker.coming
                  span Мусоровоз №345 (Г356ПП48 rus)
                  div.progress
                    div.progress-loaded(style="width: 55%")
              div.type
                div.marker.inactive
                  span Мусоровоз №345 (Г356ПП48 rus)
                  div.progress
                    div.progress-loaded(style="width: 60%")
              div.type
                div.marker.inactive
                  span Мусоровоз №345 (Г356ПП48 rus)
                  div.progress
                    div.progress-loaded(style="width: 60%")
              div.type
                div.marker.planned
                  span Мусоровоз №345 (Г356ПП48 rus)
                  div.progress
                    div.progress-loaded(style="width: 60%")
          //-div.type-group
            div.group.info
              div.type
                span.marker.active На линии
              div.type
                span.marker.inactive На ремонте
              div.type
                span.marker.planned Недоступен

          //-div.type-group
            div.type
              label.checked
                input.checkbox(type="checkbox")
                span
                span.marker Мусоровоз №345 (Г356ПП48 rus)
              label.new-check
                input.new-checkbox(type="checkbox")
                span
            div.group
              div.type.oth-hoz
                label.checked
                  input.checkbox(type="checkbox" checked)
                  span
                  span.marker Хозяйствующий субъект
              div.type.oth-minOb
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Объекты министерства обороны
              div.type.oth-med
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Медицинские учреждения
              div.type.oth-upOrg
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Управляющие организации
              div.type.oth-individ
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Индивидуальное домовладение
              div.type.oth-garden
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Садовые, дачные партнерства
              div.type.oth-garage
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker ГСК
              div.type.oth-village
                label.checked
                  input.checkbox(type="checkbox")
                  span
                  span.marker Деревни, поселки, села




</template>

<script>
  import 'leaflet';

  window.L = L;

  export default {
    data() {
      return {
        showRight: true,
        map: [],
        markers: null
      };
    },
    methods: {
      initmap3() {
        this.map = L.map('map', {
          center: [56.84325131, 60.60611655],
          zoom: 17
        });
        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);
      }
    },
    mounted() {
      this.$store.dispatch('initelements');
      this.initmap3();
    }
  };
</script>

<style lang="scss">
  @import "../../../../node_modules/leaflet/dist/leaflet.css";
</style>
